/** backend DTO/insights_rule_based_orchestration_dto.py - insights by level (InsightsRuleBasedOrchestrationService) */

export enum ProductGroup {
  PROVIDENT = "PROVIDENT",       // קופות גמל, קרנות השתלמות, גמל להשקעה
  PURE_SAVINGS = "PURE_SAVINGS", // פוליסות חיסכון טהור
  PENSION = "PENSION",
}

/** the product groups whose fees the fee reduction screen sends (HIGH_MANAGEMENT_FEE_ALL / HIGH_SAVING_FEE_FAMILY) */
export const FEE_REDUCTION_GROUPS = [ProductGroup.PROVIDENT, ProductGroup.PURE_SAVINGS];

export enum CompletenessStatus {
  COMPLETE = "COMPLETE",
  PARTIAL = "PARTIAL",
  MISSING = "MISSING",
}

export interface ProductGroupCompleteness {
  reported_period: string;
  handler_code: string;
  product_group: ProductGroup;
  status: CompletenessStatus;
  policies: number;
  funds_sum: number;
  previous_period?: string | null;
  previous_policies?: number | null;
  previous_funds_sum?: number | null;
}

export interface HandlerCalculationStatus {
  completeness: ProductGroupCompleteness;
  calculated_at?: string | null;
  insights_count?: number | null;
}

/** a producer's state across product groups: calculated / data still arriving / nothing yet */
export type HandlerCalcState = "CALCULATED" | "PARTIAL" | "MISSING";

export interface InsightCalculationStatus {
  reported_period: string;
  handlers: HandlerCalculationStatus[];
  portfolio_calculated_at?: string | null;
  period_deadline: string; // the period counts as complete by then at the latest
}

export interface RecalculatedHandler {
  handler_code: string;
  product_group: ProductGroup;
  completeness_status: CompletenessStatus;
  insights_count?: number | null;
  error?: string | null;
}

/** a whole period recalculated by hand - its monthly insights deleted first (pre-advice ones are not touched) */
export interface PeriodRecalculation {
  reported_period: string;
  deleted_insights: number;
  policy_insights: number;
  producers_calculated: number;
  producer_insights: number;
  actions: Record<string, number>;
  failed: string[];
}
